import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import type { Category } from '@/types/prompt';
import * as Icons from 'lucide-react';

interface CategoryFilterProps {
  categories: Category[];
  selectedCategory: string | null;
  onSelectCategory: (categoryId: string | null) => void;
}

export function CategoryFilter({
  categories,
  selectedCategory,
  onSelectCategory,
}: CategoryFilterProps) {
  // 获取图标组件
  const getIcon = (iconName: string) => {
    const Icon = (Icons as any)[iconName];
    return Icon ? <Icon className="w-4 h-4" /> : null;
  };

  return (
    <div className="flex flex-wrap gap-2">
      {/* 全部分类 */}
      <Button
        variant={selectedCategory === null ? 'default' : 'outline'}
        size="sm"
        onClick={() => onSelectCategory(null)}
        className="relative"
      >
        全部
        {selectedCategory === null && (
          <motion.div
            layoutId="category-indicator"
            className="absolute inset-0 bg-white/10 rounded-md -z-10"
            transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
          />
        )}
      </Button>

      {/* 各个分类 */}
      {categories
        .sort((a, b) => a.order - b.order)
        .map((category) => (
          <Button
            key={category.id}
            variant={selectedCategory === category.id ? 'default' : 'outline'}
            size="sm"
            onClick={() => onSelectCategory(category.id)}
            className="relative"
          >
            {getIcon(category.icon)}
            <span className="ml-2">{category.name}</span>
            {selectedCategory === category.id && (
              <motion.div
                layoutId="category-indicator"
                className="absolute inset-0 bg-white/10 rounded-md -z-10"
                transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
              />
            )}
          </Button>
        ))}
    </div>
  );
}

